// Auth Pages
import ForgotPassword from 'pages/auth/forgot-password'
import ConfirmAccount from 'pages/auth/confirm-account'
import Login from './pages/auth/login'
import Register from './pages/auth/register'
import ResetPassword from './pages/auth/reset-password'

// App Pages
import Dashboard from 'pages/dashboard'
import Grila from 'pages/grile'
import Home from 'pages/home'
import Payment from 'pages/payment'
import Subiect from 'pages/subiect'
import Ranking from './pages/clasament'
import Unsubscribe from 'pages/unsubscribe'
import ChangePassword from 'pages/change-password'
import Feedback from 'pages/feedback'
import Invoices from './pages/invoices'
import Istoric from 'pages/istoric'
import GrilaCreator from './pages/create-grid'
import MailCreator from './mail/creator'
import GrileReports from './pages/grile/reports'
import Teacher from './pages/teacher'
import VoucherCreator from 'pages/payment/create-voucher'
import CreateSubject from 'pages/create-subject'
import Profile from 'pages/profile'

// Other Pages
import Terms from 'pages/terms'
import PrivacyPolicy from 'pages/privacy-policy'

// Utilities
import { Navigate, Route, Routes } from 'react-router'
import { useContext } from 'react'
import { AuthContext } from 'context'
import pages from 'constants/pages'

const authRoutes = [
  {
    route: pages.auth.login,
    component: <Login />,
  },
  {
    route: pages.auth.register,
    component: <Register />,
  },
  {
    route: pages.auth.forgotPassword,
    component: <ForgotPassword />,
  },
  {
    route: pages.auth.resetPassword,
    component: <ResetPassword />,
  },
  {
    route: pages.auth.unsubscribe,
    component: <Unsubscribe />,
  },
  {
    route: pages.auth.confirmAccount,
    component: <ConfirmAccount />,
  },
]

const appRoutes = [
  {
    route: pages.app.home,
    component: <Home />,
  },
  {
    route: pages.app.grid,
    component: <Grila />,
  },
  {
    route: pages.app.subject,
    component: <Subiect />,
  },
  {
    route: pages.app.dashboard,
    component: <Dashboard />,
  },
  {
    route: pages.app.ranking,
    component: <Ranking />,
  },
  {
    route: pages.app.history,
    component: <Istoric />,
  },
  {
    route: pages.app.profile,
    component: <Profile />,
  },
  {
    route: pages.app.payment,
    component: <Payment />,
  },
  {
    route: pages.app.createGrid,
    component: <GrilaCreator />,
  },
  {
    route: pages.app.createMail,
    component: <MailCreator />,
  },
  {
    route: pages.app.createVoucher,
    component: <VoucherCreator />,
  },
  {
    route: pages.app.contact,
    component: <Feedback />,
  },
  {
    route: pages.app.createSubject,
    component: <CreateSubject />,
  },
  {
    route: pages.app.reports,
    component: <GrileReports />,
  },
  {
    route: pages.app.teacher,
    component: <Teacher />,
  },
]

const AppRoutes = () => {
  const authContext = useContext(AuthContext)
  const routes = authContext.isAuthenticated ? appRoutes : authRoutes

  const wrongRouteRedirect = authContext.isAuthenticated ? (
    <Route
      key="home-route"
      path="*"
      element={<Navigate to={pages.app.home} />}
    />
  ) : (
    <Route
      key="login-route"
      path="*"
      element={<Navigate to={pages.auth.login} />}
    />
  )

  const getRoutes = () => {
    let ret = routes
      .filter(route => route.route !== undefined)
      .map((route, index) => {
        return (
          <Route
            exact
            path={route.route}
            element={route.component}
            key={route.route}
          />
        )
      })

    ret = [
      ...ret,
      wrongRouteRedirect,
      <Route
        key="privacy-policy-route"
        exact
        path={pages.other.privacyPolicy}
        element={<PrivacyPolicy />}
      />,
      <Route
        key="terms-route"
        exact
        path={pages.other.termsAndConditions}
        element={<Terms />}
      />,
    ]

    return ret
  }

  return <Routes>{getRoutes()}</Routes>
}

export default AppRoutes
